var cart = require('_components/organisms/shopping-cart/shopping-cart-storage');

function RegisterContinueButton(params) {
  if (cart.getCart().courses.length) {
    this.buttonText = params.continuePurchaseText;
    this.url = params.continuePurchaseUrl;
  } else {
    this.buttonText = params.continueText;
    this.url = params.continueUrl;
  }
}

module.exports = RegisterContinueButton;
